export const getLatLngBoundsFromPins = (pins) => {
  if (!pins || pins.length < 2) {
    return null;
  }

  const lats = pins.map(({ lat }) => lat);
  const lngs = pins.map(({ lon }) => lon);
  const southWest = {
    lat: Math.min.apply(null, lats),
    lng: Math.min.apply(null, lngs),
  };
  const northEast = {
    lat: Math.max.apply(null, lats),
    lng: Math.max.apply(null, lngs),
  };
  return [southWest, northEast];
};
